export default "__VITE_ASSET__43d85bec__"